<template>
    <div class="stats">
        <h4>ROTATION TIME</h4>
        <h2>
            <slot />
        </h2>
    </div>
</template>